import {
  RESET_STATE, 
  SET_AUTH,
  SET_AUTH_PROPERTY,
  SET_PO_DATA,
  SET_ORDER_PROPERTY,
  SET_PO_TYPE,
  SET_PO_DATA_INFO,
  SET_PO_DATA_INFO_PROPERTY,
  SET_PO_APPROVED_CHECKED,
  SET_SELECT_ALL_TODAY_PO_CHECKED,
  SET_SELECT_INCOMPLETE_WEIGHING_PO_CHECKED,
  SET_SELECT_TODAYS,
  SET_PO_SUPPLIER_TYPE,
  SET_PO_DATA_APPROVED,
  SET_PO_SUPPLIER,
  SET_PO_RESTUARANT,
  SET_PO_FILTER_FIELDS,
  SET_PO_SEARCH_FIELDS,
  SET_PO_APPROVED_PAGINATION,
  SET_RL_SEARCH_FIELDS,
  SET_RL_PAGINATION,
  SET_I18N
} from '../constants/action-types';

export const resetState = (payload) => dispatch => {
  dispatch({
    type: RESET_STATE, payload
  });
  return Promise.resolve();
};

export const setAuth = (payload) => dispatch => {
    dispatch({
      type: SET_AUTH, payload
    });
    return Promise.resolve();
};

export const setAuthProperty = (payload) => dispatch => {
  dispatch({
    type: SET_AUTH_PROPERTY, payload
  });
  return Promise.resolve();
};

export const setPOData = (payload) => dispatch => {
  dispatch({
    type: SET_PO_DATA, payload
  });
  return Promise.resolve();
};

export const setOrderProperty = (payload) => dispatch => {
  dispatch({
    type: SET_ORDER_PROPERTY, payload
  });
  return Promise.resolve();
};

export const setPOType = (payload) => dispatch => {
  dispatch({
    type: SET_PO_TYPE, payload
  });
  return Promise.resolve();
};

export const setPODataInfo = (payload) => dispatch => {
  dispatch({
    type: SET_PO_DATA_INFO, payload
  });
  return Promise.resolve();
};

export const setPODataInfoProperty = (payload) => dispatch => {
  dispatch({
    type: SET_PO_DATA_INFO_PROPERTY, payload
  });
  return Promise.resolve();
};

export const setPOApprovedChecked = (payload) => dispatch => {
  dispatch({
    type: SET_PO_APPROVED_CHECKED, payload
  });
  return Promise.resolve();
};

export const setSelectAllTodayPOChecked = (payload) => dispatch => {
  dispatch({
    type: SET_SELECT_ALL_TODAY_PO_CHECKED, payload
  });
  return Promise.resolve();
};

export const setSelectIncompleteWeighingPOChecked = (payload) => dispatch => {
  dispatch({
    type: SET_SELECT_INCOMPLETE_WEIGHING_PO_CHECKED, payload
  });
  return Promise.resolve();
};

export const setSelectTodays = (payload) => dispatch => {
  dispatch({
    type: SET_SELECT_TODAYS, payload
  });
  return Promise.resolve();
};

export const setPOSupplierType = (payload) => dispatch => {
  dispatch({
    type: SET_PO_SUPPLIER_TYPE, payload
  });
  return Promise.resolve();
};

export const setPODataApproved = (payload) => dispatch => {
  dispatch({
    type: SET_PO_DATA_APPROVED, payload
  });
  return Promise.resolve();
};

export const setPOSupplier = (payload) => dispatch => {
  dispatch({
    type: SET_PO_SUPPLIER, payload
  });
  return Promise.resolve();
};

export const setPORestuarant = (payload) => dispatch => {
  dispatch({
    type: SET_PO_RESTUARANT, payload
  });
  return Promise.resolve();
};

export const setPOFilterFields = (payload) => dispatch => {
  dispatch({
    type: SET_PO_FILTER_FIELDS, payload
  });
  return Promise.resolve();
};

export const setPOSearchFields = (payload) => dispatch => {
  dispatch({
    type: SET_PO_SEARCH_FIELDS, payload
  });
  return Promise.resolve();
};

export const setPOApprovedPagination = (payload) => dispatch => {
  dispatch({
    type: SET_PO_APPROVED_PAGINATION, payload
  });
  return Promise.resolve();
};

export const setRLSearchFields = (payload) => dispatch => {
  dispatch({
    type: SET_RL_SEARCH_FIELDS, payload
  });
  return Promise.resolve();
};

export const setRLPagination = (payload) => dispatch => {
  dispatch({
    type: SET_RL_PAGINATION, payload
  });
  return Promise.resolve();
};

export const setI18N= (payload) => dispatch => {
  dispatch({
    type: SET_I18N, payload
  });
  return Promise.resolve();
};